import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import Content from '../../components/Pages/ReferralTemplates';

const { displayName } = config;

export default function ReferralTemplates(): React.ReactNode | null {
  document.title = `${displayName}: Referral templates settings`;

  return (
    <Layout
      title="Referral Templates Settings"
    >
      <Content />
    </Layout>
  );
}
